import React from 'react'
import { array, number, object, setLocale, string } from 'yup'
import { Form, Row, Col } from 'antd'
import { FormikProps, FormikValues } from 'formik'
import moment from 'moment'

import { DatePickerRange, SelectStatus } from 'src/components/Formik'
import { Option } from 'src/components/Formik/Select'
import SelectOrganizationCurrentManager from 'src/components/Formik/select-organization-current-manager'

function getInitialValues() {
  return {
    ended_on: moment.utc().endOf('month').unix(),
    organization_id: '',
    started_on: moment.utc().startOf('month').unix(),
    status: null as string[]
  }
}

const options: Option[] = [
  {
    label: 'common.status.unified.underway',
    value: 'underway'
  },
  {
    label: 'common.status.unified.approval_pending',
    value: 'approval_pending'
  },
  {
    label: 'common.status.unified.conference_pending',
    value: 'conference_pending'
  },
  {
    label: 'common.status.unified.closing_pending',
    value: 'closing_pending'
  }
]

function getRenderForm() {
  return (formikProps: FormikProps<FormikValues>) => (
    <Form onSubmit={formikProps.handleSubmit}>
      <Row>
        <Col span={24}>
          <SelectOrganizationCurrentManager
            formikProps={formikProps}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <DatePickerRange
            formikProps={formikProps}
            label="web.reports.parameter.period.title"
            name={['started_on', 'ended_on']}
            placeholder={[
              'web.reports.parameter.period.placeholder-start',
              'web.reports.parameter.period.placeholder-end'
            ]}
            required
            showTime={false}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <SelectStatus
            formikProps={formikProps}
            label="web.select-status.label"
            name="status"
            options={options}
            required={false}
          />
        </Col>
      </Row>
    </Form>
  )
}

function getValidationSchema() {
  setLocale({
    mixed: {
      notType: 'common.required',
      required: 'common.required'
    }
  })

  return object().shape({
    ended_on: number().required().typeError(),
    organization_id: string().required(),
    started_on: number().required().typeError(),
    status: array().notRequired()
  })
}

export { getRenderForm, getValidationSchema, getInitialValues }
